<template>
  <div>
    <el-button
      style="margin-bottom: 10px"
      @click="openDrawerAmonestacion"
      type="primary"
      icon="el-icon-plus"
      circle
    ></el-button>
    <div style="display: flex; float: right">
      <div class="box">
        <el-select
          v-model="value"
          clearable
          placeholder="Tipo"
          size="mini"
          @change="handleChangeType"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="box">
        <el-select
          v-model="year"
          placeholder="Año"
          size="mini"
          @change="handleChangeYear"
        >
          <el-option
            v-for="item in years"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <DirectionSelector
        @selection-change="handleChangeDirection"
      ></DirectionSelector>
    </div>
    <div>
      <rabbey-table-3
        ref="table"
        :loading="autoLoading"
        :data="AmonestacionData"
        :columns="ColumnsAmonestacion"
      ></rabbey-table-3>
    </div>
    <AmonestacionesReportForMes
      :showDrawerAmonestacionReport="showDrawerAmonestacionReport"
      :UserId="IdUser"
      :Month="Month"
      :year="year2"
      :type="tipo2"
      @dialog-closed="closeDrawerDetalles"
      :before-close="closeDrawerDetalles"
      @refreshTable="getDataAmonestacion"
    ></AmonestacionesReportForMes>
    <AddRequestAmonestacion
      ref="AddRequestAmonestacion"
      :drawerAmonestacionOrigen.sync="drawerAmonestacion"
      :before-close="closeDrawerAmonestacion"
      @dialog-closed="closeDrawerAmonestacion"
      :isCreatedProp="isCreatedDrawer"
      @refreshTable="getDataAmonestacion"
    >
    </AddRequestAmonestacion>
  </div>
</template>

<script>
import ColumnsAmonestacion from "@/columns/ColumnsAmonestacion";
import DirectionSelector from "@/components/Company/DirectionSelector.vue";
import AmonestacionesReportForMes from "@/views/apps/employees/RRHH/Modules/Amonestacion/AmonestacionesReportForMes.vue";
import AddRequestAmonestacion from "@/views/apps/employees/RRHH/Modules/Amonestacion/DrawerAmonestacion.vue";

export default {
  name: "Amonestacion",
  components: {
    DirectionSelector,
    AmonestacionesReportForMes,
    AddRequestAmonestacion
  },
  data() {
    return {
      ColumnsAmonestacion: ColumnsAmonestacion,
      AmonestacionData: [],
      year: new Date().getFullYear(),
      directionId: 0,
      autoLoading: false,

      drawerAmonestacion: false,
      isCreatedDrawer: false,

      //PARA ABRIR DRAWER DETALLE
      Month: 0,
      IdUser: 0,
      year2: 0,
      tipo2: 0,
      showDrawerAmonestacionReport: false,

      //SELECT FILTRO TIPO
      options: [
        {
          value: "1",
          label: "Amonestacion"
        },
        {
          value: "2",
          label: "Llamados Atencion"
        }
      ],
      value: "",
      tipo: 0
    };
  },

  computed: {
    years() {
      const lowLevel = 2014;
      const currentYear = new Date().getFullYear();
      let Years = [];
      for (var i = lowLevel; i <= currentYear + 1; i++) {
        Years.push({ label: i, value: i });
      }
      return Years;
    }
  },

  methods: {
    getDataAmonestacion() {
      this.autoLoading = true;
      let params = {
        year: this.year == 0 ? null : this.year,
        directionId: this.directionId == 0 ? null : this.directionId,
        Type: this.tipo == 0 ? null : this.tipo,
        IdEmployee:
          this.currentUser.EmployeeId == 37 ||
          this.IsInRoles([this.roles.GerenteRRHH])
            ? null
            : this.currentUser.EmployeeId
      };
      this.$http
        .get("/api/Modules/GetAmonestacionList", { params })
        .then((resp) => {
          this.AmonestacionData = resp.data;
          this.AmonestacionData.forEach((dataForEach) => {
            dataForEach.OpenDetailAmonestacion = this.OpenDetailAmonestacion;
          });
        })
        .finally(() => {
          this.autoLoading = false;
        });
    },
    handleChangeYear(year) {
      this.year = year;
      this.getDataAmonestacion();
    },

    handleChangeDirection(directionId) {
      this.directionId = directionId;
      this.getDataAmonestacion();
    },

    handleChangeType(type) {
      this.tipo = type;
      this.getDataAmonestacion();
    },

    OpenDetailAmonestacion(row, month, years, types) {
      let mtn;
      switch (month) {
        case "Enero":
          mtn = 1;
          break;
        case "Febrero":
          mtn = 2;
          break;
        case "Marzo":
          mtn = 3;
          break;
        case "Abril":
          mtn = 4;
          break;
        case "Mayo":
          mtn = 5;
          break;
        case "Junio":
          mtn = 6;
          break;
        case "Julio":
          mtn = 7;
          break;
        case "Agosto":
          mtn = 8;
          break;
        case "Septiembre":
          mtn = 9;
          break;
        case "Octubre":
          mtn = 10;
          break;
        case "Noviembre":
          mtn = 11;
          break;
        case "Diciembre":
          mtn = 12;
          break;
        default:
      }
      this.IdUser = row.IdEmployee;
      this.Month = mtn;
      this.year2 = years;
      this.tipo2 = types;
      this.showDrawerAmonestacionReport = true;
    },

    openDrawerAmonestacion() {
      this.drawerAmonestacion = true;
      this.isCreatedDrawer = true;
    },

    closeDrawerAmonestacion() {
      this.drawerAmonestacion = false;
      this.isCreatedDrawer = false;
    },

    closeDrawerDetalles() {
      this.showDrawerAmonestacionReport = false;
    }
  },
  mounted() {
    this.getDataAmonestacion();
  },
  watch: {
    refresh() {
      this.getDataAmonestacion();
    }
  }
};
</script>
